import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-2/3 max-w-3xl p-8" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "mb-4 text-3xl" }, "Profile", -1)
const _hoisted_3 = {
  key: 0,
  class: "p-8 border rounded shadow-xl bg-primary-dark"
}
const _hoisted_4 = { class: "flex pb-8 mb-8 text-xl border-b" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "" }, [
  /*#__PURE__*/_createVNode("div", { class: "mb-1" }, "Name:"),
  /*#__PURE__*/_createVNode("div", { class: "mb-1" }, "Email:"),
  /*#__PURE__*/_createVNode("div", { class: "mb-1" }, "Role:")
], -1)
const _hoisted_6 = { class: "ml-8" }
const _hoisted_7 = {
  class: "mb-1",
  "data-testid": "user-name-value"
}
const _hoisted_8 = {
  class: "mb-1",
  "data-testid": "user-email-value"
}
const _hoisted_9 = {
  class: "mb-1",
  "data-testid": "user-role-value"
}
const _hoisted_10 = { class: "flex-shrink-0 ml-auto" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Sign out")
const _hoisted_12 = {
  key: 1,
  class: "p-8 border rounded shadow-xl bg-primary-dark"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profile_photo_component = _resolveComponent("profile-photo-component")
  const _component_button_component = _resolveComponent("button-component")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.user)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, _toDisplayString(_ctx.user.displayName), 1),
              _createVNode("div", _hoisted_8, _toDisplayString(_ctx.user.email), 1),
              _createVNode("div", _hoisted_9, _toDisplayString(_ctx.userRoleLabel(_ctx.user.role)), 1)
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_profile_photo_component, {
                class: "w-24 h-24 lg:w-32 lg:h-32",
                user: _ctx.user
              }, null, 8, ["user"])
            ])
          ]),
          _createVNode(_component_button_component, { onClick: _ctx.onLogout }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_12, " Please login to view profile "))
  ]))
}